module.exports = __webpack_public_path__ + "img/good_casper_white.bb18185b.png";